import { render, staticRenderFns } from "./LogAsOrigin.vue?vue&type=template&id=75ebcfb2&"
import script from "./LogAsOrigin.vue?vue&type=script&setup=true&lang=js&"
export * from "./LogAsOrigin.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports